
export default {
    props: ['id', 'name', 'phone', 'email', 'birthday', 'isSelected'],
    emits: ['editContact', 'deleteContact'],
    data() {
        return {
            editFormVisible: false,
            copiedInfo: null
        };
    },
    computed: {
        infoList() {
            return [
                { data: this.phone, title: this.$t('contacts.list.item.info.phone') },
                { data: this.email, title: this.$t('contacts.list.item.info.email') },
                { data: this.birthday, title: this.$t('contacts.list.item.info.birthday') }
            ];
        },
        dummyImage() {
            const [firstLetter, secondLetter] = this.name.split(' ').map((word: string) => word[0]);
            return `https://dummyimage.com/150x150/80cbc4/ffffff.gif&text=${firstLetter ?? ''}${secondLetter ?? ''}`;
        }
    },
    methods: {
        callContact() {
            window.open('tel:' + this.phone);
        },
        writeContact() {
            window.open('mailto:' + this.email);
        },
        async scrollToContact() {
            await this.$nextTick();

            if (this.isSelected) {
                const el = this.$refs.panel.$el;
                el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    }
};
